import ThemedComponent from '../../../hoc/ThemedComponent';
import NewsListItem from './NewsListItem';
import NewsListItem3 from '../../../themes/3/components/News/NewsListItem';
import NewsListItem4 from '../../../themes/4/components/News/NewsListItem';

const ThemedNewsListItem = {
  default: NewsListItem,
  // 3: NewsListItem3,
  // 4: NewsListItem4,
};

export default ThemedComponent(ThemedNewsListItem);